import script from "./ActivityHtmlEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityHtmlEditor.vue?vue&type=script&setup=true&lang=js"

import "./ActivityHtmlEditor.vue?vue&type=style&index=0&id=3c7ab070&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c7ab070"]])

export default __exports__